/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TabsData } from 'app/components/multi-module-picker/multi-module-picker.interface';
import { MultiModulePickerService } from 'app/components/multi-module-picker/multi-module-picker.service';
import _ from 'lodash';
import { UtilityService } from '../utility_functions/utility_functions.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { AnalyticsService } from '../analytics/analytics.service';
import { ActivatedRoute, Params, Router, UrlSerializer } from '@angular/router';
import { LocalStorageService } from '../localstorage.service';
@Injectable({
    providedIn: 'root'
})
export class ProjectsService {
    get projectsUrl(): any {
      return `${this.dataCollectorService.baseurl()}/projects/`;
    }
   
    refreshGanttView: Subject<any> = new Subject<any>();
    currentProjectDetails = new BehaviorSubject<any>(null);
    public deleteSubject = new Subject<any>();

    deleteNotification$ = this.deleteSubject.asObservable();

    constructor(
        private dataCollectorService: DataCollectorService,
        private multiModulePickerService: MultiModulePickerService,
        private utilityService: UtilityService,
        private zuperDialogService: ZuperDialogService,
        private analyticsService: AnalyticsService,
        private router: Router,
        private serializer: UrlSerializer,
        private route: ActivatedRoute,
        private localStorageService: LocalStorageService
        ) { }

    get projectsGridUrls(): any {
      return {
        columnUrl: `${this.dataCollectorService.baseurl()}/projects/meta`,
        dataUrl: `${this.dataCollectorService.baseurl()}/projects/filter`,
        filterUrl: `${this.dataCollectorService.baseurl()}/projects/meta/filter`,
        bulkActionUrl: `${this.dataCollectorService.baseurl()}/projects/bulk_action`,
      }
    };
    get estimateUrl(): any {
      return `${this.dataCollectorService.baseurl()}/estimate`;
    }
    get invoiceUrl(): any {
      return `${this.dataCollectorService.baseurl()}/invoice`;
    }
    get jobsUrl(): any {
      return `${this.dataCollectorService.baseurl()}/jobs`;
    }
    get serviceContractUrl(): any {
      return `${this.dataCollectorService.baseurl()}/service_contract`;
    }
    get projectAssignUrl(): any {
      return `${this.dataCollectorService.baseurl()}/projects/`+ 'assign';
    }
    get projectCategoryUrl(): any {
      return `${this.dataCollectorService.baseurl()}/projects/` + 'category';
    }

    projectsDetailsUrl(projectsUid: string): string{
        return `${this.dataCollectorService.baseurl()}/projects/` + `${projectsUid}`;
    }
    notifyDelete(data: any): any {
      this.deleteSubject.next(data);
    }
    

    getProjectDetails(projectUid): Observable<any>{
      const projectUrl = this.projectsDetailsUrl(projectUid);
      return this.dataCollectorService.getData(projectUrl);
    }

    getMasterProjectsStatus(): Observable<any> {
        const url =  `${this.dataCollectorService.baseurl()}/projects/` + 'status';
        return this.dataCollectorService.getData(url);
    }

    getProjectStatus(category_uid: string): Observable<any> {
        const url =  `${this.dataCollectorService.baseurl()}/projects/` + 'status';
        const payload = {
            project_category_uid: category_uid,
        };
        return this.dataCollectorService.getData(url, payload);
    }

    updateProjectStatus(project_uid, payload): Observable<any>{
        const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/status`;
        return this.dataCollectorService.putData(projectStatusUrl,payload);
    }

    getTransactionHistory(projectUid, lineItemUid,params): Observable<any>{
      const projectTransactionUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}/products/transactions/${lineItemUid}`;
      return this.dataCollectorService.getData(projectTransactionUrl,params);
    }

    getProjectStatusRollbackUrl(project_uid): string{
        return `${this.dataCollectorService.baseurl()}/projects/${project_uid}/status/rollback`;
    }

    deleteProject(projectUid: string): any{
        const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}`;
        return this.dataCollectorService.deleteData(url);
    }

  deletePhase(projectUid: string, phaseUid: string, params: any): any {
    const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}` + '/phases/' + `${phaseUid}`;
    return this.dataCollectorService.deleteData(url, params);
  }

  deleteMilestone(projectUid: string, milestoneUid: string): any {
    const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}` + '/milestone/' + `${milestoneUid}`;
    return this.dataCollectorService.deleteData(url);
  }

  updateMilestoneStatus(projectUid: string, milestoneUid: string, params: any): any {
    const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}` + '/milestone/' + `${milestoneUid}` + '/status';
    return this.dataCollectorService.putData(url, params);
  }

  checkDependency(projectUid: string, params: any): any {
    const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}` + '/dependencies/check';
    return this.dataCollectorService.postData(url, params);
  }

  deleteDependency(projectUid: string, dependencyUid: string): any {
    const url = `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}` + '/dependencies/' + `${dependencyUid}`;
    return this.dataCollectorService.deleteData(url);
  }

    getProjectAttachmentUrl(projectUid: string): string {
        return `${this.dataCollectorService.baseurl()}/projects/` + `${projectUid}/attachments`;
    }

    updateProject(projectUid: string, payload: any): Observable<any>{
        const url = `${this.dataCollectorService.baseurl()}/projects/` + projectUid;
        return this.dataCollectorService.putData(url, payload);
    }

    getProductDetails(projectUid: string,productUid: string): Observable<any>{
      const url = `${this.dataCollectorService.baseurl()}/projects/${projectUid}/products/${productUid}`;
      return this.dataCollectorService.getData(url);
    }

    manualConsume(lineItemUid: any,payload: any,projectUid: any): Observable<any>{
      const url = `${this.dataCollectorService.baseurl()}/projects/${projectUid}/products/${lineItemUid}/consumption`;
      return this.dataCollectorService.postData(url,payload);
    }

    updateProjectParts(lineItemUid: any,payload: any,projectUid: any): Observable<any>{
      const url = `${this.dataCollectorService.baseurl()}/projects/${projectUid}/products/${lineItemUid}`;
      return this.dataCollectorService.putData(url,payload);
    }

    deleteProjectParts(lineItemUid: any,payload: any,projectUid: any): Observable<any>{
      const url = `${this.dataCollectorService.baseurl()}/projects/${projectUid}/products/${lineItemUid}`;
      return this.dataCollectorService.deleteData(url,payload);
    }

    getProjectParts(projectUid: any, params: any): Observable<any>{
      const url = `${this.dataCollectorService.baseurl()}/projects/${projectUid}/products`;
      return this.dataCollectorService.getData(url,params);
    }

    getProjectServiceContracts(payload): Observable<any> {
        return this.dataCollectorService.getData(this.serviceContractUrl, payload);
    }

    assignEmployeeToProject(payload): Observable<any>{
        return this.dataCollectorService.postData(this.projectAssignUrl, payload);
    }

    getProjectUpdateUrl(projectId: string): string {
        return `${this.dataCollectorService.baseurl()}/projects/${projectId}/update`;
    }

    getProjectCategory(): Observable<any>{
        return this.dataCollectorService.getData(this.projectCategoryUrl);
    }

    setMultiModulePickerTabs(projectUid: string): void {
        const tabs: Array<TabsData> = [
            {
                'displayName': 'Customer',
                'displayKey': 'customer',
                'dataKey': 'CUSTOMER',
                'module': 'CUSTOMER',
                'dataUrl': '/customers',
              },
              {
                'displayName': 'Organization',
                'displayKey': 'text.organization',
                'dataKey': 'ORGANIZATION',
                'module': 'ORGANIZATION',
                'dataUrl': '/organization',
              },
          {
            'displayName': 'Property',
            'displayKey': 'text.property',
            'dataKey': 'PROPERTY',
            'module': 'PROPERTY',
            'dataUrl': '/property',
          },{
            'displayName': 'Quotes',
            'displayKey': 'text.quotes',
            'dataKey': 'ESTIMATES',
            'module': 'ESTIMATES',
            'dataUrl': '/estimate',
          },{
            'displayName': 'Contract',
            'displayKey': 'contract',
            'dataKey': 'SERVICE_CONTRACTS',
            'module': 'SERVICE_CONTRACTS',
            'dataUrl': '/service_contract',
          },
          {
            'displayName': 'ASSETS',
            'displayKey': 'asset.text',
            'dataKey': 'ASSETS',
            'module': 'ASSETS',
            'dataUrl': '/assets',
          }
        ];
        this.multiModulePickerService.setTabs(tabs);
      }
    addFilterRule(oldFilterRules: any[] = [], newFilterRules: any | any[]): any[] {
        oldFilterRules = _.cloneDeep(oldFilterRules);
        newFilterRules = _.cloneDeep(newFilterRules);
        if (newFilterRules) {
            if (typeof newFilterRules === 'object') {
                newFilterRules = [newFilterRules];
            }
            newFilterRules.forEach((newRule: any) => {
                oldFilterRules = oldFilterRules.filter((oldRule: any) => oldRule.key !== newRule.key);
                oldFilterRules.push(newRule);
            });
        }
        return oldFilterRules;
    }

    removeFilterKey(key: string | string[], filterRules: any[]): any {
        let _filterRules = _.cloneDeep(filterRules);
        if (!key || !_filterRules || !_filterRules?.length) { return _filterRules; }
        _filterRules = _filterRules.filter((filterRule: any) => {
          if(typeof key === 'string') {
            return filterRule.key !== key;
          }
          else if(typeof key === 'object') {
            return !key.includes(filterRule.key);
          }
        });
        return _filterRules;
      }

      removeFilterKeyWithValue(key: string, value: string, filterRules: any[]): any {
        let _filterRules = _.cloneDeep(filterRules);
        if (!key || !_filterRules || !_filterRules?.length) { return _filterRules; }
        _filterRules = _filterRules.filter((filterRule: any) => !(filterRule?.key === key && filterRule?.value === value));
        return _filterRules;
      }

      isSameFilterRule(filterRuleOne: any[], filterRuleTwo: any[]): boolean {
        let isSame: boolean = false;
        if (!filterRuleOne || !filterRuleTwo) { return false; }
        if(filterRuleOne.length === filterRuleTwo.length){
          let isDiff: boolean = false;
          _.forEach(filterRuleOne, (filterRule: any) => {
            const valueRuleOne = filterRule?.value;
            const valueRuleTwo = _.find(filterRuleTwo, {key: filterRule?.key})?.value;
            if(!_.isEqual(valueRuleOne, valueRuleTwo)) {
              isDiff = true;
              return false;
            }
          });
          isSame = !isDiff;
        }
        return isSame;
      }

  projectDetailsChangeConfirmationDialog(projectDetails: any, jobDetails: any, type: 'detach' | 'delete'): MatDialogRef<any> {
    const prefix = _.get(jobDetails, 'prefix') || '';
    const workOrderNumber = _.get(jobDetails, 'work_order_number') || '';
    const jobTitle = _.get(jobDetails, 'job_title') || '';
    const jobIdTitle = this.getTitle(prefix, workOrderNumber, jobTitle);

    const projectPrefix = _.get(projectDetails, 'project_prefix') || '';
    const projectNumber = _.get(projectDetails, 'project_number') || '';
    const projectTitle = _.get(projectDetails, 'project_name') || '';
    const projectIdTitle = this.getTitle(projectPrefix, projectNumber, projectTitle);
    let dialogTitle: string; let dialogMessage: string;
    let confirmLabel: string; let confirmDisplayKey: string;
    let color: string = 'primary';

    if (type === 'detach') {
      dialogTitle = `${this.utilityService.getLocaleValue('text.detach', 'Detach')} '${jobIdTitle}'`;
      dialogMessage = `${this.utilityService.getLocaleValue('project.detach_job.confirmation')} <span class="text-gray-900 font-medium">
          '${jobIdTitle}'</span> from <span class="text-gray-900 font-medium"> '${projectIdTitle}'</span> ?`;
      confirmLabel = 'Detach';
      confirmDisplayKey = 'text.detach';
      color = 'error';
    }
    const confirmationDialog = this.zuperDialogService.open({
      title: dialogTitle,
      type: 'error',
      message: dialogMessage,
      actions: {
        confirm: {
          show: true,
          label: confirmLabel,
          color: color,
          confirmDisplayKey: confirmDisplayKey,
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'dispatchBoard.scheduler.dialog.delete.cancel'
        }
      },
      dismissible: false,
      extraClass: 'job-delete-dialog'
    });
    return confirmationDialog;
  }

  getTitle(prefix: string, eventNumber: string, eventTitle: string): string {
    return `#${prefix || ''}${eventNumber || ''} ${eventTitle || ''}`;
  }

  isProjectJobLimitReached(count: number): boolean{
    return count > 50;
  }

  updateProjectJobQueryParam(urlPath: string, selectedTab: 'LIST' | 'GANTT' | 'RESET', isLeftNavCollapse?: 'collapse' | 'open'): any {
    if (!isLeftNavCollapse) {
      const leftNavStatus = this.route.snapshot.queryParams['left_nav'];
      if (leftNavStatus) {
        isLeftNavCollapse = this.route.snapshot.queryParams['left_nav'];
      }
      else {
        isLeftNavCollapse = 'collapse';
      }
    }
    if (!selectedTab) {
      const selectedTabStatus = this.route.snapshot.queryParams['current_tab'];
      if (selectedTabStatus) {
        selectedTab = this.route.snapshot.queryParams['current_tab'];
      }
      else {
        selectedTab = 'GANTT';
      }
    }
    let params: any =  {current_tab: selectedTab, left_nav: isLeftNavCollapse};
    let queryParamsHandling: any = 'merge';
    if (selectedTab === 'RESET') {
      params = {};
      queryParamsHandling = '';
    }
    this.router.navigate(
      [urlPath],
      {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: queryParamsHandling
      }
    );
  }
  getTimeLogEntry(jobId): any {
    const timelogUrl = `${this.dataCollectorService.baseurl()}/timelog`
    return this.dataCollectorService.getData(timelogUrl)
  }
  postTimeLogEntry(payload): any {
    const timelogUrl = `${this.dataCollectorService.baseurl()}/timelog`
    return this.dataCollectorService.postData(timelogUrl, payload);
  }
  updateTimeLogEntry(jobUid: any, timelogUid: any, payload): any {
    const timelogUrl = `${this.dataCollectorService.baseurl()}/timelog/${timelogUid}`
    return this.dataCollectorService.putData(timelogUrl, payload);
  }
  deleteTimeLogEntry(payload): any {
    const params = {
      'remove_associated_entry':true
    };
    if(payload?.job_uid){
      params['job_uid'] = payload?.job_uid;
    }
    if(payload?.project_uid){
      params['project_uid'] = payload?.project_uid;
    }
    const timelogUrl = `${this.dataCollectorService.baseurl()}/timelog/${payload?.timelog_uid}/`;
    return this.dataCollectorService.deleteData(timelogUrl, params);
  }
  getTimeLogGroups(params): any{
    const queryString =
    'from_date=' + encodeURIComponent(params.fromdate) +
    '&to_date=' + encodeURIComponent(params.todate) +
    '&project_uid=' + encodeURIComponent(params.projectuid) +
    '&group_by=' + encodeURIComponent(params.groupBy);

    const timelogGroupUrl = `${this.dataCollectorService.baseurl()}/timelog_summary/group?${queryString}`
    return this.dataCollectorService.getData(timelogGroupUrl);

  }
  getTimelogUrl(user,date,id): string {
    let queryString =
    'from_date=' + encodeURIComponent(date) +
    '&to_date=' + encodeURIComponent(date) +
    '&user_uid=' + encodeURIComponent(user.user_uid);
    if(id?.project){
      queryString += '&project_uid=' + encodeURIComponent(id?.project?.project_uid) + '&only_project_timelog=true&obtain_paired_timelogs=true';
    }
    else{
      queryString += '&job_uid=' + encodeURIComponent(id?.job?.job_uid) + '&obtain_paired_timelogs=true';
    }

    return `${this.dataCollectorService.baseurl()}/timelog_summary/?${queryString}`;
}
getTimelogsUrl(projectId: string): string {
  return `${this.dataCollectorService.baseurl()}/timelog_summary/?project_uid=${projectId}`;
}

  addPhase(project_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/phases`;
    return this.dataCollectorService.postData(projectStatusUrl,payload);
  }

  updatePhase(project_uid, phase_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/phases/${phase_uid}`;
    return this.dataCollectorService.putData(projectStatusUrl,payload);
  }

  reorderPhase(project_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/phases/reorder`;
    return this.dataCollectorService.putData(projectStatusUrl,payload);
  }

  updatePhaseItems(project_uid, phase_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/phases/${phase_uid}/item`;
    return this.dataCollectorService.postData(projectStatusUrl,payload);
  }

  reorderPhaseItems(project_uid, phase_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/phases/${phase_uid}/reorder`;
    return this.dataCollectorService.putData(projectStatusUrl,payload);
  }

  addMilestone(project_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/milestone`;
    return this.dataCollectorService.postData(projectStatusUrl,payload);
  }

  updateMilestone(project_uid, milestone_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/milestone/${milestone_uid}`;
    return this.dataCollectorService.putData(projectStatusUrl,payload);
  }

  createDependency(project_uid, payload): Observable<any>{
    const projectStatusUrl = `${this.dataCollectorService.baseurl()}/projects/` + `${project_uid}/dependencies`;
    return this.dataCollectorService.postData(projectStatusUrl,payload);
  }

  detachJob(url): Observable<any> {
    const jobUpdateUrl = `${this.dataCollectorService.baseurl()}/${url}`;
    return this.dataCollectorService.deleteData(jobUpdateUrl);
  }

  trackEvent(event: string | string[], tab: ProjectDetailsSideBarTabs): void {
    if (event) {
      let eventName: string = `project_${tab.toLowerCase()}_`;
      if (typeof event === 'string') {
        eventName += event.toLowerCase();
        this.analyticsService.trackEvent(eventName);
      }
      else if (typeof event === 'object' && event.length) {
        event.forEach((_event: any) => {
          eventName = `project_${tab.toLowerCase()}_`;
          eventName += _event.toLowerCase();
          this.analyticsService.trackEvent(eventName);
        });
      }
    }
  }
}
export type ProjectDetailsSideBarTabs = 'DETAILS' | 'JOBS' | 'FINANCIAL' | 'NOTES' | 'ACTIVITY';
